import React from "react"
import { graphql } from "gatsby"
import { RichText } from "prismic-reactjs"
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'

import Layout from "../components/layout/layout"
import SEOnew from "../components/seo-new"
import htmlSerializer from "../utils/htmlSerializer"

const SimplePageTemplate = ({ data }) => {
  const doc = data.prismicSimplePage

  return (
    <Layout>
      <SEOnew 
        title={doc.data.page_title ? doc.data.page_title : null}
        noIndex={doc.data.page_no_index ? true : false}
      />
      
      <div className="bg-gray-50 py-12">
        <div className="w-11/12 max-w-2xl mx-auto">
          <h2 className="text-site-lightblue text-3xl text-center font-bold mb-6">{doc.data.section_title ? doc.data.section_title : "Section Title"}</h2>

          {doc.data.section_content.richText
            ?
            <RichText
              render={doc.data.section_content.richText}
              htmlSerializer={htmlSerializer}
            />
            :
            <>
              <p className='text-lg text-gray-800 text-center'>Section content here, and more..</p>
            </>
          }          
        </div>
      </div>
    </Layout>
  )
}

export default withPrismicPreview(SimplePageTemplate)

export const SimplePageTemplateQuery = graphql`
  query($id: String!) {
    prismicSimplePage(id: { eq: $id }) {
      _previewable
      uid
      data {
        page_title
        page_no_index
        section_title
        section_content {
          richText
        }
      }
    }
  }
`


